import { Modal, ModalProvider, Text } from '@joor/design-system'

import usePortal from 'hooks/usePortal'

import messages from 'features/Linesheets/Modals/ManageImagesModal/manageImagesModal.messages'

interface DiscardChangesModalProps {
  isModalOpen: boolean
  text: string
  handleOnClose: () => void
  onConfirm: () => void
}

const DiscardChangesModal = ({
  isModalOpen,
  text,
  handleOnClose,
  onConfirm,
}: DiscardChangesModalProps) => {
  const Portal = usePortal()

  return (
    <Portal>
      <ModalProvider>
        <Modal
          title={{
            text: messages.discardChangesQuestion,
          }}
          isOpen={isModalOpen}
          onClose={handleOnClose}
          size="small"
          disableBackgroundClick
        >
          <Modal.Content>
            <Text
              fontFamily="alpha"
              fontSize="base"
              fontWeight="medium"
              letterSpacing="tight"
            >
              {text}
            </Text>
          </Modal.Content>
          <Modal.Actions
            primaryButton={{
              text: messages.discardChanges,
              handler: onConfirm,
            }}
            secondaryButtonText={messages.cancel}
          />
        </Modal>
      </ModalProvider>
    </Portal>
  )
}

export default DiscardChangesModal
